import React from "react";

const AsUsersIcon = ({ size = 12, color = "none", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.49995 11H1.99995C1.99995 9.23675 3.3038 7.77805 4.99995 7.53545M9.93625 8.1019C9.90215 8.10395 9.8678 8.105 9.8333 8.105C9.32105 8.105 8.8538 7.8762 8.49995 7.5C8.1461 7.8762 7.67885 8.10495 7.1666 8.10495C7.1321 8.10495 7.09775 8.1039 7.06365 8.10185C7.02205 8.29265 6.99995 8.49275 6.99995 8.69895C6.99995 9.80605 7.63735 10.7363 8.49995 11C9.36255 10.7363 9.99995 9.80605 9.99995 8.69895C9.99995 8.49275 9.97785 8.29265 9.93625 8.1019ZM7.49995 4C7.49995 5.10457 6.6045 6 5.49995 6C4.39538 6 3.49995 5.10457 3.49995 4C3.49995 2.89543 4.39538 2 5.49995 2C6.6045 2 7.49995 2.89543 7.49995 4Z"
      stroke="currentColor"
      stroke-width="0.9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default AsUsersIcon;
